/** 결제 실패 FE 관리 코드 */
export const ApplyFail = {
    ORDER_PROCESS_ALREADY_STARTED: 'orderProcessAlreadyStarted',
} as const
